import { render, staticRenderFns } from "./UnitXp.vue?vue&type=template&id=07139b9c&scoped=true&"
import script from "./UnitXp.vue?vue&type=script&lang=js&"
export * from "./UnitXp.vue?vue&type=script&lang=js&"
import style0 from "./UnitXp.vue?vue&type=style&index=0&id=07139b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07139b9c",
  null
  
)

export default component.exports